export const firebaseSensitiveConfigs = {
  apiKey: "AIzaSyAhTdvSNpd5zda-d83FBTwQolx4FOM1S4U",
  authDomain: "cocoon-22320.firebaseapp.com",
  projectId: "cocoon-22320",
  storageBucket: "cocoon-22320.appspot.com",
  messagingSenderId: "698328422158",
  appId: "1:698328422158:web:eb520d9602dac17de1e95f",
};
